import React, { useCallback, useMemo } from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { includeNonConcludedSourceCaptions } from './report-card-access.helpers';
import { ReportCardAvailabilityMessages } from './report-card-access.types';
import { useReportCardAvailabilityStyles } from './report-card-availability.styles';

interface ISendReportCardsSettingProps {
  availability: IReportCardAvailability;
  messages: ReportCardAvailabilityMessages;
  disabled: boolean;
  saving: boolean;
  // A boolean saves the age group's own choice; null clears it so the default applies again.
  onChange: (value: boolean | null) => void;
}

// The effective include-non-concluded value and where it comes from; changing it saves the age group's choice.
export const SendReportCardsSetting: React.FC<ISendReportCardsSettingProps> = ({ availability, messages, disabled, saving, onChange }) => {
  const classes = useReportCardAvailabilityStyles();
  const captions = useMemo(() => includeNonConcludedSourceCaptions(messages), [messages]);
  const source = availability.includeNonConcludedSource;

  const handleToggle = useCallback((event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked), [onChange]);
  const useDefault = useCallback(() => onChange(null), [onChange]);

  return (
    <div>
      <div className={classes.inline}>
        <FormControlLabel
          control={<Switch color="primary" checked={availability.includeNonConcluded} disabled={disabled} onChange={handleToggle} />}
          label={<IntlMsg {...messages.lblIncludeNonConcluded} />}
        />
        {saving && <CircularProgress size={16} />}
      </div>
      <div className={classes.settingCaption}>
        <Typography variant="caption" color="textSecondary"><IntlMsg {...captions[source]} /></Typography>
        {source === 'AGE_GROUP' && (
          <Button size="small" color="primary" disabled={disabled} onClick={useDefault}>
            <IntlMsg {...messages.btnUseDefault} />
          </Button>
        )}
      </div>
    </div>
  );
};
